import React from 'react'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import classNames from 'classnames'

const styleSheet = theme => ({
    container: {
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: theme.zIndex.modal,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
})

const style = injectSheet(styleSheet)

const Modal = ({ classes, className, open, children }) => {
    return open && <div className={classNames(classes.container, className)}>{children}</div>
}

export default compose(
    style,
    pure
)(Modal)
